import { render, staticRenderFns } from "./veiculo.vue?vue&type=template&id=97ac3f0a"
import script from "./veiculo.vue?vue&type=script&lang=js"
export * from "./veiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports